import { z } from "zod";

/**
 * The settings someone keeps on the share server, so every device they sign in on looks and works the same. Text
 * size isn't in it, as it depends on the size of the screen. The app checks the names of colours itself, so an older
 * app ignores ones it doesn't know yet.
 */
export const SyncedSettings = z.object({
    theme: z.object({
        mode: z.string().max(20),
        accent: z.string().max(20),
        chords: z.string().max(20),
    }),
    display: z.object({
        lyricsOnly: z.boolean(),
        splitSections: z.boolean(),
        sectionSpacing: z.number().min(0).max(10),
        lineSpacing: z.number().min(0).max(10),
        chordSize: z.number().min(0).max(10),
        font: z.string().max(20),
    }),
    general: z.object({
        holdToArrange: z.boolean(),
    }),
});

export type SyncedSettings = z.infer<typeof SyncedSettings>;

/**
 * `PUT /settings`, and the answer to it and to `GET /settings`: the settings, and when a device changed them. The
 * share server keeps the latest, so a device that was offline can't overwrite newer settings with older ones; it gets
 * the newer ones back instead.
 */
export const SavedSettings = z.object({
    settings: SyncedSettings,
    changedAt: z.iso.datetime(),
});

export type SavedSettings = z.infer<typeof SavedSettings>;
